import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listHydraulicsLogs = (payload) => (dispatch) => {
  const { hydraulicsLogs } = store.getState();

  dispatch({
    type: REDUX_ACTIONS.HYDRAULICS_LOGS_LIST_LOADING,
  });

  const body = {
    query: {
      startDate: payload?.startDate || hydraulicsLogs?.startDate,
      endDate: payload?.endDate || hydraulicsLogs?.endDate,
      searchValue: payload?.searchValue || hydraulicsLogs?.searchValue,
      limit: 100,
      page: payload?.page || 1,
      filters: convertFiltersToV5Format(hydraulicsLogs?.filters?.items) || [],
      linkOperator: hydraulicsLogs?.filters?.logicOperator || '',
      sort: hydraulicsLogs?.sort || null
    }
  };

  return fetch
    .post('audit/hydraulics', body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LOGS_LIST_SUCCESS,
        payload: {
          hydraulicsLogs: data.data,
          paginatedElements: data.data.count,
          totalCount: data.count
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.HYDRAULICS_LOGS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const downloadHydraulicsLogs = (disableLoader) => (dispatch) => {
  const { hydraulicsLogs } = store.getState();

  const body = {
    searchValue: hydraulicsLogs?.searchValue || '',
    startDate: hydraulicsLogs?.startDate || '',
    endDate: hydraulicsLogs?.endDate || '',
    input: hydraulicsLogs?.filters?.items || [],
    logicOperator: hydraulicsLogs?.filters?.logicOperator || '',
    sort: hydraulicsLogs?.sort || null
  };

  const path = 'audit/hydraulics/downloadCSV';
  return fetch
    .post(path, body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      // Convert JSON data to CSV format
      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'POT_hydraulics_logs.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      disableLoader();
      dispatch(
        enqueueSnackbar(
          'File downloaded successfully',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      disableLoader();
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};
